import { inferDateForAmbiguousTime, type TimeConstraints } from "./inferDateForAmbiguousTime";

export interface ClockInConstraints extends TimeConstraints {}

/**
 * Infers the correct date for an ambiguous clock-in time.
 *
 * The time picker only shows hours and minutes (e.g., "1:00 AM"), which creates
 * ambiguity for overnight shifts. For example, in a 10 PM - 2 AM shift:
 * - "1:00 AM" could mean 1 AM on the first day (before shift start)
 * - "1:00 AM" could mean 1 AM on the second day (during the shift)
 *
 * This function uses constraints (arrival time, clock-out time) to determine
 * which date the user intended.
 *
 * @param ambiguousTime - Time from picker with potentially wrong date
 * @param originalClockInTime - Original clock-in time (provides date context)
 * @param constraints - Constraints to help resolve ambiguity
 * @returns The time with correct date inferred
 */
export function inferDateForAmbiguousClockInTime(
  ambiguousTime: Date,
  originalClockInTime: Date,
  constraints: ClockInConstraints
): Date {
  return inferDateForAmbiguousTime(ambiguousTime, originalClockInTime, constraints);
}
